export default {
  namespaced: true,
  state: {
    TEMP_local_storage_redirect_is_checked: false,
  },
  mutations: {
    setLocalStorageRedirectIsChecked(state, data) {
      state.TEMP_local_storage_redirect_is_checked = data;
    },
  },
  actions: {
    verifyLocalStorageRedirectIsChecked(context) {
      context.commit('setLocalStorageRedirectIsChecked', true);
    },
  },
  getters: {
    TEMP_local_storage_redirect_is_checked: (state) => {
      return state.TEMP_local_storage_redirect_is_checked;
    },
  },
};
